//Checkout
import Error404 from '../Pages/Error404';
import BaseLayout from '../Components/Layout/BaseLayout';

const Routes = [
    {
        path: 'proceso-suscripcion/*',
        component: BaseLayout,
    },
    {
        path: '/not-found',
        component: Error404,
    },
];

export default Routes;
